// Import dependencies
import React from 'react';
import axios from 'axios';
import ReCAPTCHA from 'react-google-recaptcha';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useState } from 'react';

// Import helper functions
import { checkTokenIfLoggedIn } from '../../../../helper';

// Import config
import config from '../../../../configs/config.json';
const AUTH_URL = config.AUTH_URL;
const RECAPTCHA_SITE_KEY = config.RECAPTCHA_SITE_KEY;

class RegisterPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            credentials: {
                email: '',
                confirmEmail: '',
                password: '',
                confirmPassword: '',
                memberID: '',
                recaptchaCode: '', 
                terms: false
            },
            invalidEmail: false,
            invalidPassword: false,
            showPassword: false,
            invalidMemberID: false,
            failedRecaptchaChallenge: false,
            failedTermsAgreement: false,
            message: '',
            success: false
        }

        this.recaptchaRef = React.createRef();
    }

    componentDidMount = () => {
        // Check if the user is already logged in
        checkTokenIfLoggedIn();

        // Add a key down listener
        document.addEventListener("keydown", this._handleKeyDown);
    }

    _handleKeyDown = (event) => {
        if(event.keyCode === 13) {
            // When the [ENTER] key is pressed, fire off the back-end auth call to register a user
            this.submitRegister();
        }
    }

    handleChange = (field) => (event) => {
        var credentials = this.state.credentials;
        var newValue = event.target.value;

        if(field === 'memberID') {
        
            // Keep the member ID within 9 characters to avoid error
            if(newValue.length <= 9) {
                credentials[field] = newValue.toUpperCase();
                this.setState({ credentials });
            } 
            
        } else if(field === 'terms') {
            credentials[field] = !credentials.terms;
            this.setState({ credentials })
        } else {
            credentials[field] = newValue;
            this.setState({ credentials });
        }
    }

    onRacaptchaChange = (value) => {
        var credentials = this.state.credentials;
        credentials.recaptchaCode = value;
        this.setState({ credentials })
    }

    toggleShowPassword = () => {
        this.setState({ showPassword: !this.state.showPassword });
    }

    emailIsValid = () => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.state.credentials.email);
    }

    memberIdIsValid = () => {
        return /^[GM]\d{2}[OFS]\d{5}|Z[a-zA-Z0-9]{8}$/.test(this.state.credentials.memberID);
    }

    submitRegister = () => {
        var credentials = this.state.credentials;

        console.log(credentials);

        
        if(this.emailIsValid()) {
            this.setState({
                invalidEmail: false,
                message: ''
            });

            if(credentials.email !== credentials.confirmEmail) {
                this.setState({
                    invalidEmail: true,
                    message: "Emails don't match."
                });
            } else if(credentials.password === credentials.confirmPassword) {
                this.setState({
                    invalidPassword: false,
                    message: ''
                });
                if(credentials.password === '') {
                    this.setState({
                        invalidPassword: true,
                        message: 'Password cannot be blank.'
                    });

                } else if(this.memberIdIsValid()) {
                    this.setState({
                        invalidMemberID: false,
                        invalidPassword: false,
                        message: ''
                     });

                    if(this.state.credentials.terms === false) {
                        this.setState({
                            failedTermsAgreement: true,
                            message: "You must agree to the terms and conditions."
                        });
                    } else if(this.state.credentials.recaptchaCode !== '') {
                        axios.post(`${AUTH_URL}/register`, { credentials: this.state.credentials })
                        .then(result => {
                            
                            var data = result.data;
                            console.log(data);

                            if(data.success) {
							    console.log('Successfully registered.');
                                this.setState({ success: true, message: `Welcome, ${data.contact.name}! An email has been sent to ${this.state.credentials.email}. Please check your inbox to verify your email address.` });
                            } else {
                                this.recaptchaRef.current.reset();
                                if(data.olliMemberIDUsed) {
                                    let message = <span>This OLLI Member ID is already associated with a video access account.  Try logging in to your existing account- click here to continue:  <a href="https://olli.ce.uci.edu/">here</a></span>
                                    this.setState({ message, invalidMemberID: true });
                                } else if(data.specialAccessCodeInvalid) {
                                    this.setState({ invalidMemberID: true, message: data.message });
                                }
                                else if (data.specialAccessCodeUsed) {
                                    let message = <span>This OLLI Member ID is already associated with a video access account.  Try logging in to your existing account- click here to continue:  <a href="https://olli.ce.uci.edu/">here</a></span>
                                    this.setState({ invalidMemberID: true, message });
                                } else {
                                    console.log('Failed to register user.');
                                    this.setState({ message: data.message });
                                }
                            }
                        })
                        .catch(error => {
                            console.log(error);
                            console.log('type ', typeof(error))
                            this.setState({ message: 'Server error' })
                        })
                    } else {
                        this.setState({
                            failedRecaptchaChallenge: true,
                            message: 'Please complete challenge.'
                        })
                    }
                } else {
                    this.setState({
                        invalidMemberID: true,
                        message: 'Please enter a valid OLLI member ID as found on your OLLI ID card.'
                     });
                }
            } else {
                this.setState({
                    invalidPassword: true,
                    message: 'Passwords don\'t match.'
                });
            }
        } else {
            this.setState({ invalidEmail: true, message: 'Enter a valid email address.' });
        }
    }
	openPanel = () => this.setState({ isOpen: true });
    	closePanel = () => this.setState({ isOpen: false });
	
    render() {
        return (
		<>
		<style>{`
		        .side-panel {
		          position: fixed;
		          top: 45px;
		          right: -100%;
		          width: 400px;
		          height: 100%;
		          background-color: white;
		          box-shadow: -2px 0 10px rgba(0,0,0,0.1);
		          transition: right 0.3s ease;
		          z-index: 1000;
		          padding: 20px;
		        }
		
		        .side-panel.open {
		          right: 0;
		        }
		
		        .video-wrapper {
		          position: relative;
		          padding-top: 56.25%;
		        }
		
		        .video-wrapper iframe {
		          position: absolute;
		          top: 0;
		          left: 0;
		          width: 100%;
		          height: 100%;
		          border: none;
		        }
		
		        .close-button {
		          flex: 1;
		          font-size: 1em;
		          background: none;
		          cursor: pointer;
	    		  margin-right: 15px;
	 		  padding-bottom: 25px;
      			  text-decoration: underline;
		        }

     			.panel-row {
			 text-align: center;
    			 width: 100%;
			 height: auto;
    			 flex-direction: row;
			 justify-content: flex-start;
			}
	      `}</style>
            <div className='container'>
                <div className='card'>
                    <div className='card-body'>
                        <h2 style={{textAlign: 'center', color: 'black', fontSize: 24, fontWeight: 'bold'}} className='card-title'>Registration</h2>
                    
                        <label htmlFor='#emailInput'>Email</label>
                        <input id='emailInput' className={(this.state.invalidEmail) ? 'form-control is-invalid' : 'form-control' } type='text' placeholder='Email' value={this.state.credentials.email} onChange={this.handleChange('email')} />

                        <label style={{marginTop: 15}} htmlFor='#confirmEmailInput'>Confirm Email</label>
                        <input id='confirmEmailInput' className={(this.state.invalidEmail) ? 'form-control is-invalid' : 'form-control' } type='text' placeholder='Confirm Email' value={this.state.credentials.confirmEmail} onChange={this.handleChange('confirmEmail')} />

                        <label style={{marginTop: 15}} htmlFor='#passwordInput'>Video Password</label>&nbsp;
                        { (this.state.showPassword) ?
                            <FaEyeSlash  title='Hide password' size='1.5em' onClick={this.toggleShowPassword} />
                        :
                            <FaEye title='Show password' size='1.5em' onClick={this.toggleShowPassword} />
                        }
                        <input id='passwordInput' className={(this.state.invalidPassword) ? 'form-control is-invalid' : 'form-control' } type={(this.state.showPassword)? 'text' : 'password'} placeholder='Video Password' value={this.state.credentials.password } onChange={this.handleChange('password')} />
                        
                        <label style={{marginTop: 15}} htmlFor='#confirmPasswordInput'>Confirm Video Password</label>
                        <input id='confirmPasswordInput' className={(this.state.invalidPassword) ? 'form-control is-invalid' : 'form-control' } type={(this.state.showPassword)? 'text' : 'password'} placeholder='Confirm Video Password' value={this.state.credentials.confirmPassword} onChange={this.handleChange('confirmPassword')} />
                        
                        <label style={{marginTop: 15}} htmlFor='#memberIdInput'>OLLI Member ID</label>
                        <input id='memberIdInput' className={(this.state.invalidMemberID) ? 'form-control is-invalid' : 'form-control' } type='text' placeholder='OLLI Member ID' value={this.state.credentials.memberID} onChange={this.handleChange('memberID')} />
                        
                        <div style={{borderColor: 'red'}} className='is-invalid'>
                            <ReCAPTCHA
                                ref={this.recaptchaRef}
                                style={(this.state.failedRecaptchaChallenge) ? { marginTop: 15, border: '1px solid red', borderRadius: '5px' } : { marginTop: 15 }}
                                sitekey={RECAPTCHA_SITE_KEY}
                                onChange={this.onRacaptchaChange}
                            />
                        </div>

                        <div className='form-check' style={{marginTop: 15}}>
                            <label className="form-check-label" htmlFor="termsCheckBox">
                            <input className={ (this.state.failedTermsAgreement) ? "form-check-input is-invalid" : "form-check-input" } type="checkbox" value={this.state.credentials.terms} id="termsCheckBox" onChange={this.handleChange('terms')} />
                                I agree to the <a href="/terms" target="_blank">Terms and Conditions</a>
                            </label>
                        </div>
                        

                        { (this.state.message) ? <div style={{marginTop: 15}} className={(this.state.success)? 'alert alert-success': 'alert alert-danger'} id='messageBox'><p>{this.state.message}</p></div> : '' }
                        
                        {(this.state.success) ? <div style={{ marginTop: 15, display: 'flex', flexDirection: 'row', justifyContent: 'center', textAlign: 'center'}}> 
                                                    <button className='btn btn-primary' onClick={ () => window.location.href='/login' }>Done</button>                    
                                                </div>
                        
                        : <div style={{ marginTop: 15, display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                            <button className='btn btn-secondary' onClick={this.openPanel}>View Tutorial</button>
                            <button className='btn btn-primary' onClick={this.submitRegister}>Next</button>
                        </div>}
                        
                    </div>
                </div>
				
		<div className={`side-panel ${this.state.isOpen ? 'open' : ''}`} id="videoPanel">
			<div className={'panel-row'}>
			<button className="close-button" onClick={this.closePanel}>× Close</button>
			<h3 style={{flex: 1}}>How to Set Up Your OLLI Account</h3>
			</div>
			<div className="video-wrapper">
				<iframe src="https://player.vimeo.com/video/1099439916?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" 
					allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" 
					title="ORLC Tutorial (7.7.25)"></iframe>
			</div>
		</div>
            </div>
	</>
        );
    }
}

export default RegisterPage;
